import React from "react";
import { Input, SelectOptions, TextArea, SaveProgress } from "components";
import { ColorPicker } from "components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as styles from "./editTextComponent.styles";
import Modal from "@material-ui/core/Modal";
import { borderContainer } from "../editTemplate.styles";
import { H2 } from "appStyles";

export default class EditTextComponent extends React.Component {
  update = (field) => (value) => {
    const { component } = this.props;
    const updatedComponent = {
      ...component,
    };
    updatedComponent.view[field] = value;
    this.props.updateComponent(updatedComponent);
  };

  updateFontSize = (fontSize) => {
    const { component } = this.props;
    const updatedComponent = {
      ...component,
    };
    updatedComponent.view.fontSize = Number(fontSize);
    this.props.updateComponent(updatedComponent);
  };

  updateColor = (color) => {
    const { component } = this.props;
    const updatedComponent = {
      ...component,
    };
    updatedComponent.view.textColor = color;
    this.props.updateComponent(updatedComponent);
  };

  setClickAction = (templateId) => {
    const { component } = this.props;
    const updatedComponent = {
      ...component,
    };
    updatedComponent.view.clickAction = {
      type: "templateSegue",
      templateId: parseInt(templateId),
    };
    this.props.updateComponent(updatedComponent);
  };

  toggleStyle = (style) => () => {
    const { component } = this.props;
    const currentStyle = component.view[style];
    if (currentStyle === "undefined") return;
    const updatedComponent = {
      ...component,
    };

    updatedComponent.view[style] = !currentStyle;
    this.props.updateComponent(updatedComponent);
  };

  updateTextAlignment = (alignment) => () => {
    const { component } = this.props;
    const updatedComponent = {
      ...component,
    };

    updatedComponent.view.alignment = alignment;
    this.props.updateComponent(updatedComponent);
  };

  setFont = (font) => {
    const { component } = this.props;
    const updatedComponent = {
      ...component,
    };
    updatedComponent.view.font = font;
    this.props.updateComponent(updatedComponent);
  };

  toggleActiveEditor = (idx) => {
    let {
      actions: { updateActiveEditor },
    } = this.props;
    // console.log("@@@@@@ closing MODAL");
    updateActiveEditor(idx);
  };
  render() {
    const { component, activeApp, onClose } = this.props;
    const { view } = component;

    const templateOptions = activeApp.view.templates.map((t) => ({
      label: t.pageName,
      value: t.id,
    }));

    const fontOptions = [
      {
        value: "Abril Fatface",
        label: "Abril Fatface",
        font: "Abril Fatface",
      },
      {
        value: "Alex Brush",
        label: "Alex Brush",
        font: "Alex Brush",
      },
      {
        value: "Anonymous Pro",
        label: "Anonymous Pro",
        font: "Anonymous Pro",
      },
      {
        value: "Domine",
        label: "Domine",
        font: "Domine",
      },
      {
        value: "Dosis",
        label: "Dosis",
        font: "Dosis",
      },
      {
        value: "EB Garamond",
        label: "EB Garamond",
        font: "EB Garamond",
      },
      {
        value: "Lato",
        label: "Lato",
        font: "Lato",
      },
      {
        value: "Petit Formal Script",
        label: "Petit Formal",
        font: "Petit Formal",
      },
      {
        value: "Playfair Display",
        label: "Playfair Display",
        font: "Playfair Display",
      },
      {
        value: "Quicksand",
        label: "Quicksand",
        font: "Quicksand",
      },
      {
        value: "Rochester",
        label: "Rochester",
        font: "Rochester",
      },
    ];

    const isBold = !!view.bold;
    const isItalic = !!view.italics;
    const isUnderline = !!view.underline;
    const isLeft = view.alignment === 0;
    const isCenter = view.alignment === 1;
    const isRight = view.alignment === 2;

    return (
      <div>
        <Modal
          open={true}
          onClose={() => onClose(null)}
          disableAutoFocus={true}
          style={{
            top: "10%",
            width: "60%",
            marginLeft: "230px",
            marginRight: "auto",
          }}
        >
          <div
            className={borderContainer}
            style={{ height: "460px", width: "auto" }}
          >
            <H2>Description Text Settings</H2>
            <div
              className={styles.inputContainer}
              style={{ alignItems: "center" }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <span style={{ marginRight: "1rem" }}>Font: </span>
                <SelectOptions
                  width="11em"
                  font={view.font}
                  options={fontOptions}
                  setValue={this.setFont}
                  value={view.font}
                  style={{ display: "inline-block" }}
                />
              </div>

              <div style={{ display: "flex", alignItems: "center" }}>
                <span>Size: </span>
                <Input
                  type="number"
                  field="Font Size"
                  width={70}
                  defaultValue={view.fontSize}
                  onChange={this.updateFontSize}
                  fontSize={15}
                  centerText
                  marginBottom={"0px"}
                />
              </div>

              <div className={styles.textStyleButtonGroup}>
                <div className={styles.flexRow}>
                  <div
                    className={styles.fontStyle}
                    onClick={this.toggleStyle("bold")}
                    style={{
                      fontWeight: "bold",
                      background: isBold ? "rgba(50,220,220,.4)" : "",
                    }}
                  >
                    B
                  </div>
                  <div
                    className={styles.fontStyle}
                    onClick={this.toggleStyle("italics")}
                    style={{
                      fontStyle: "italic",
                      background: isItalic ? "rgba(50,220,220,.4)" : "",
                    }}
                  >
                    I
                  </div>
                  <div
                    className={styles.fontStyle}
                    onClick={this.toggleStyle("underline")}
                    style={{
                      textDecoration: "underline",
                      background: isUnderline ? "rgba(50,220,220,.4)" : "",
                    }}
                  >
                    U
                  </div>
                </div>

                <div className={styles.flexRow}>
                  <FontAwesomeIcon
                    className={styles.fontStyle}
                    style={{
                      width: "2em",
                      padding: "0.1em",
                      background: isLeft ? "rgba(50,220,220,.4)" : "",
                    }}
                    onClick={this.updateTextAlignment(0)}
                    icon="align-left"
                  />
                  <FontAwesomeIcon
                    className={styles.fontStyle}
                    style={{
                      width: "2em",
                      padding: "0.1em",
                      background: isCenter ? "rgba(50,220,220,.4)" : "",
                    }}
                    onClick={this.updateTextAlignment(1)}
                    icon="align-center"
                  />
                  <FontAwesomeIcon
                    className={styles.fontStyle}
                    style={{
                      width: "2em",
                      padding: "0.1em",
                      background: isRight ? "rgba(50,220,220,.4)" : "",
                    }}
                    onClick={this.updateTextAlignment(2)}
                    icon="align-right"
                  />
                </div>
              </div>
            </div>
            <div>
              <ColorPicker
                color={view.textColor}
                title="Description Text Color:"
                onChange={this.updateColor}
              />
            </div>

            <TextArea
              text={component.view.text}
              placeholder="enter text here"
              onChange={this.update("text")}
              maxLength={Number.MAX_SAFE_INTEGER}
              marginBottom={"20px"}
            />
            <SaveProgress />
          </div>
        </Modal>
      </div>
    );
  }
}
